import { render } from "./selected-dashboard.vue?vue&type=template&id=963c251c&ts=true"
import script from "./selected-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./selected-dashboard.ts?vue&type=script&lang=ts&external"

import "./selected-dashboard.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__